<template>
    <div class="locket-wrapper">
        <figure>
            <picture>
                <img :src="`/imgs/web/${this.name}.webp`" :srcset="`/imgs/web/${this.name}.webp 1x, /imgs/web/${this.name}@2x.webp 2x`" :alt="`${this.people[this.name].position} - Vitadio`">
            </picture>
        </figure>
        <div>
            <strong class="new-text-lg name">{{ this.people[this.name].name }}</strong>
            <strong class="new-text-md text-violet position">{{ this.people[this.name].position }}</strong>
            <a class="text-color-default" :href="`tel:${this.people[this.name].phone}`">
                <figure>
                    <span class="material-symbols-rounded">phone</span>
                </figure>
                <span class="new-text-md">{{ this.people[this.name].phone }}</span>
            </a>
            <a class="text-color-default" :href="`mailto:${this.people[this.name].email}`">
                <figure>
                    <span class="material-symbols-rounded">mail</span>
                </figure>
                <span class="new-text-md">
                    {{ this.people[this.name].email }}
                </span>
            </a>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        name: {
            type: String,
            required: true,
            default: 'marie',
            validator: function(value) {
                return ['marie', 'tamara'].indexOf(value) !== -1
            }
        },

    },

    data(){
        return {
            people: {
                marie: {
                    name: 'Marie Veselá',
                    position: 'Head of People & Operations',
                    phone: '+420 730 803 352',
                    email: 'marie.vesela@vitad.io'
                },
                tamara: {
                    name: 'Tamara Chichua',
                    position: 'People Operations Generalist',
                    phone: '+420 775 470 734',
                    email: 'tamara.chichua@vitad.io'
                }
            }

        }
    },


    methods: {
    }
}

</script>

